const weddingParty = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'Maid of Honor',
    bio: 'Sarah has been my best friend since college. She\'s the most loyal and fun person I know!',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=688&q=80',
    side: 'bride',
  },
  {
    id: 2,
    name: 'Emily Chen',
    role: 'Bridesmaid',
    bio: 'My wonderful sister who always knows how to make me laugh.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    side: 'bride',
  },
  {
    id: 3,
    name: 'Jessica Martinez',
    role: 'Bridesmaid',
    bio: 'My college roommate and lifelong friend. Always up for an adventure!',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=688&q=80',
    side: 'bride',
  },
  {
    id: 7,
    name: 'Amanda Rodriguez',
    role: 'Bridesmaid',
    bio: 'My cousin and childhood partner in crime. She brings joy wherever she goes.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=1361&q=80',
    side: 'bride',
  },
  {
    id: 8,
    name: 'Sophia Williams',
    role: 'Bridesmaid',
    bio: 'My work bestie who became family. She\'s always there with the best advice.',
    image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80',
    side: 'bride',
  },
  {
    id: 9,
    name: 'Isabella Garcia',
    role: 'Bridesmaid',
    bio: 'My high school best friend who knows all my secrets. The sweetest soul I know.',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=764&q=80',
    side: 'bride',
  },
  {
    id: 4,
    name: 'Michael Rodriguez',
    role: 'Best Man',
    bio: 'My brother and best friend. He\'s always had my back through everything.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    side: 'groom',
  },
  {
    id: 5,
    name: 'David Thompson',
    role: 'Groomsman',
    bio: 'My best friend since high school. The most reliable guy I know.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80',
    side: 'groom',
  },
  {
    id: 6,
    name: 'James Wilson',
    role: 'Groomsman',
    bio: 'My college buddy and travel companion. Always ready for the next adventure.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80',
    side: 'groom',
  },
  {
    id: 10,
    name: 'Carlos Mendoza',
    role: 'Groomsman',
    bio: 'My cousin who\'s more like a brother. He brings the fun to every gathering.',
    image: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=1035&q=80',
    side: 'groom',
  },
  {
    id: 11,
    name: 'Ryan Parker',
    role: 'Groomsman',
    bio: 'My workout partner and motivator. He keeps me grounded and focused.',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80',
    side: 'groom',
  },
  {
    id: 12,
    name: 'Alex Turner',
    role: 'Groomsman',
    bio: 'My childhood friend and gaming partner. He\'s been there since day one.',
    image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-4.0.3&auto=format&fit=crop&w=1148&q=80',
    side: 'groom',
  },
]

export function WeddingParty() {
  const brideParty = weddingParty.filter(person => person.side === 'bride')
  const groomParty = weddingParty.filter(person => person.side === 'groom')

  return (
    <div className="min-h-screen bg-neutral-50">
      <div className="section-padding">
        <div className="container-max">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-serif text-primary-900 mb-4">
              Wedding Party
            </h1>
            <p className="text-lg text-neutral-600 max-w-2xl mx-auto">
              Meet the special people who will be standing with us on our big day.
            </p>
          </div>

          {/* Bride's Party */}
          <div className="mb-16">
            <h2 className="text-3xl font-serif text-primary-900 text-center mb-8">
              Bride's Party
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {brideParty.map((person) => (
                <div key={person.id} className="card text-center p-6">
                  <div className="relative mb-6">
                    <img
                      src={person.image}
                      alt={person.name}
                      className="w-32 h-32 rounded-full mx-auto object-cover"
                    />
                  </div>
                  
                  <h3 className="text-xl font-serif text-primary-900 mb-2">
                    {person.name}
                  </h3>
                  
                  <p className="text-sm text-primary-600 font-medium mb-4">
                    {person.role}
                  </p>
                  
                  <p className="text-neutral-600 text-sm leading-relaxed">
                    {person.bio}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Groom's Party */}
          <div>
            <h2 className="text-3xl font-serif text-primary-900 text-center mb-8">
              Groom's Party
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {groomParty.map((person) => (
                <div key={person.id} className="card text-center p-6">
                  <div className="relative mb-6">
                    <img
                      src={person.image}
                      alt={person.name}
                      className="w-32 h-32 rounded-full mx-auto object-cover"
                    />
                  </div>
                  
                  <h3 className="text-xl font-serif text-primary-900 mb-2">
                    {person.name}
                  </h3>
                  
                  <p className="text-sm text-primary-600 font-medium mb-4">
                    {person.role}
                  </p>
                  
                  <p className="text-neutral-600 text-sm leading-relaxed">
                    {person.bio}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 